<template>
  <b-form-group v-if="sidebar" class="sidebar-language">
    <b-form-radio-group v-model="activeLang" buttons>
      <b-form-radio
        @change="switchLanguage"
        :key="lang.key"
        v-for="lang in languages"
        :value="lang.value"
        class="text-capitalize m-1 p-1 pl-3 pr-3"
      >
        {{ lang.value }}
      </b-form-radio>
    </b-form-radio-group>
  </b-form-group>
  <b-form-group v-else-if="!dropDown">
    <b-form-radio-group v-model="activeLang" buttons button-variant="info">
      <b-form-radio
        @change="switchLanguage"
        :key="lang.key"
        v-for="lang in languages"
        :value="lang.value"
        class="button--transparent text-capitalize"
      >
        <b-img
          fluid
          :src="require(`@/assets/images/${lang.value}.svg`)"
          rounded="circle"
          class="pr-1 pb-1"
        />
        {{ lang.value }}
      </b-form-radio>
    </b-form-radio-group>
  </b-form-group>
  <b-dropdown v-else right size="sm" no-caret class="language activeRole">
    <template #button-content>
      <div class="button--icon h-100">
        <b class="text-primary font-weight-normal text-uppercase">
          {{ activeLang }}
        </b>
        <Icon
          name="mdi_chevron-right1"
          class="dropdown-indicator"
          rotate="-90"
          font-scale="1.5"
        />
      </div>
    </template>
    <b-dropdown-item-button
      button-class="text-uppercase text-primary px-2"
      :key="lang.key"
      v-for="lang in languages"
      :value="lang.value"
      @click="saveActiveLang(lang.value)"
    >
      {{ lang.value }}
    </b-dropdown-item-button>
  </b-dropdown>
</template>

<script>
import { API_LOCALE } from "@/constants/constants";
import Icon from "@/components/Icon/Icon";
import { loadLanguageAsync } from "@/plugins/i18n";
import { mapGetters } from "vuex";
import Cookies from "js-cookie";
import { ROUTE_NAMES } from "@/constants/routeConstants";

export default {
  name: "Lang",
  components: {
    Icon,
  },
  data() {
    return {
      activeLang: null,
    };
  },
  props: {
    dropDown: { type: Boolean, default: false },
    sidebar: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters({
      profile: "user/profile",
      isAuthenticated: "auth/isAuthenticated",
    }),
    languages() {
      return API_LOCALE;
    },
  },
  async mounted() {
    const sessionLang = this.$cookies.get("sessionLang");
    this.activeLang = process.env.VUE_APP_I18N_LOCALE;

    if (this.$route.params.locale) {
      const twoLetter = API_LOCALE.filter((obj) => {
        return obj.key === this.$route.params.locale;
      });
      this.activeLang = twoLetter[0].value;
    } else if (this.profile.language) {
      this.activeLang = this.profile.language;
    } else if (sessionLang) {
      this.activeLang = sessionLang;
    }
    /* if (this.activeLang !== this.$i18n.locale) {
      await loadLanguageAsync(this.activeLang);
    } */
    if (!this.$route.params.locale) {
      this.putLangToURL();
    }
  },

  methods: {
    saveActiveLang(lang) {
      this.activeLang = lang;
      this.switchLanguage();
      if (this.isAuthenticated) {
        this.$store.dispatch("user/changeLang", lang);
      }
    },
    putLangToURL() {
      let routeName = this.$route.name;
      const twoLetter = API_LOCALE.filter((obj) => {
        return obj.value === this.activeLang || obj.key === this.activeLang;
      });
      if (!this.$route.name) {
        routeName = ROUTE_NAMES.login;
      }
      this.$router.replace({
        name: routeName,
        params: { locale: twoLetter[0].key },
      });
    },

    switchLanguage() {
      Cookies.set("sessionLang", this.activeLang);
      this.putLangToURL();
      loadLanguageAsync(this.activeLang);
    },
  },
};
</script>
